import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { shallow } from 'zustand/shallow';
import { captureAdClick } from '../brain/adAttribution';
import { useUIStore } from '#store';

/**
 * The document snippet already records the first PageView so the ad click id
 * is stored before React loads. Later client navigations are sent from here.
 */
export default function MetaPageViews() {
  const location = useLocation();
  const isFirst = useRef(true);
  const { sendFBEvent } = useUIStore(
    (state) => ({ sendFBEvent: state.sendFBEvent }),
    shallow
  );

  useEffect(() => {
    captureAdClick();
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    sendFBEvent({ eventName: 'PageView' });
  }, [location.pathname, location.search, sendFBEvent]);

  return null;
}
